<template>
  <section id="here" style="height: 100vh;">
    <div :style="{ display: isShow }">
      <div class="loading_wrap" :style="{ display: isLodingShow }">
        <div class="download-header">프로그램 설치안내</div>
        <div class="download-contents">
          프로그램을 다운로드 받은 후 설치해주세요.
        </div>
        <div class="download-btn-wrap" style="background: white;">
          <div id="downloadBtn" @click="downloadClient()">
            설치파일 다운로드
          </div>
          <br />
          <div id="closeBtn" @click="winClose()">닫기</div>
        </div>
      </div>
    </div>
    <confirm
      :dialog="confirmDialog.dialog"
      :contents="confirmDialog.contents"
      :agree="confirmAgree"
      :closeDialog="closeConfirm"
    />
    <check-password
      :dialog="checkPasswordDialog.dialog"
      :meetingInfo="checkPasswordDialog.meetingInfo"
      :closeDialog="closePassword"
      @joinPwMeeting="joinPwMeeting"
    />
  </section>
  
</template>
<script>
import menu from "@/api/menu";
import { mapState } from "vuex";
import moment from "moment";
import timezone from "moment-timezone";
import debounce from "lodash.debounce";
import Confirm from '@/components/popup/Confirm';
import CheckPassword from '@/components/popup/CheckPassword';
import Util from "@/util";

export default {
  components: {
    Confirm,
    CheckPassword,
  },
  data: () => ({
    isLodingShow: "none",
    startMeetingItem: {},
    isShow: "",
    bodaFileLink: null,
    meetingInfo: {
      meetingType: null,
      meetingMode: null,
    },
    videoMeetingCreateDialog: {
      dialog: false,
    },
    lectureMeetingCreateDialog: {
      dialog: false,
    },
    citizenParticipationDialog: {
      dialog: false,
    },
    confirmDialog: {
      dialog: false,
      contents: '',
    },
    checkPasswordDialog: {
      dialog: false,
      meetingInfo: {},
    },
    isCheckedPassword: false,
  }),
  created () {
    this.joinLink = this.$window.location.href;
    this.startMeeting();
  },
  methods: {
    openConfirmDialog () {
      this.confirmDialog.dialog = true;
      this.confirmDialog.contents = '이 회의는 녹화가 될 수 있습니다.';
      // this.startMeetingItem = item;
    },
    async startMeeting () {
      let userKey = this.getURLParameter("userKey");
      let meetingKey = this.getURLParameter("meetingKey");
      let isMb = this.getURLParameter("isMb");
      if (!meetingKey || !userKey) {
        alert('잘못된 접근');
        return;
      }

      let meetingInfo = {
        meetingKey: meetingKey,
        userKey: userKey,
      };
      this.$http
        .get("/api/v1/meetings/attendMeetingToUrl", { params: meetingInfo })
        .then(response => {
          let data = response.data;
          if (data.err && data.err === 'license') {
            alert('현재 사용량이 많아 시스템 관리자에게 문의 부탁드립니다.');
            return false;
          }

          if (data.meetingInfo.exMeeting) {
            alert('이 회의는 스마트 단말기만 접속 가능합니다.');
            return false;
          }

          if (data.meetingInfo === null) {
            alert(
              "영상회의 방이 존재하지 않습니다. 회의 15분 전부터 참석 가능합니다."
            );
            this.$window.open("", "_self").close();
            this.$window.close();
            return false;
          } else if (data.meetingInfo.status === "r") {
            alert("영상회의 시작 전입니다.");
            this.$window.open("", "_self").close();
            this.$window.close();
            return false;
          } else if (data.meetingInfo.status === "e") {
            alert("종료된 회의입니다.");
            this.$window.open("", "_self").close();
            this.$window.close();
            return false;
          } else if (data.meetingInfo.status === "d") {
            alert("삭제된 회의입니다.");
            this.$window.open("", "_self").close();
            this.$window.close();
            return false;
          }

          let creator = data.meetingInfo.creator.email;
          let userInfo = data.userInfo;
          console.log(data.userInfo)
          //userKey를 이메일로 초대링크 발송
          if (userInfo === creator) {
            console.log("#개설자#");
          } else {
            console.log("#개설자 아닐 경우");
            if (!userInfo.empNum) {
              alert("초대되지 않은 사용자입니다.");
              window.open("", "_self").close();
              window.close();
            } else {
              console.log("#초대된 사용자#");
            }
          }
          if (data.meetingInfo.isPrivate && this.isCheckedPassword === false) {
            // 비공개 회의일 경우 패스워드 입력창 띄워야함
            this.checkPasswordDialog.dialog = true;
            this.checkPasswordDialog.meetingInfo = data.meetingInfo;
            return false;
          }

          let params = {
            email: userInfo.email,
            meetingKey: meetingKey,
          };

          let saehaAuthenticationUrl = "";
          if (data.meetingInfo.exMeeting === true) {
            if (data.meetingInfo.conferenceRoomActive === true) {
              // DMZ(외부망) - CMS 미팅
              saehaAuthenticationUrl = "/api/auth/dmzSaehaInfo";
            } else {
              // DMZ (외부망) - 일반회의
              saehaAuthenticationUrl = "/api/auth/joinUrlForDmzSaehaInfo";
            }
          } else {
            if (data.meetingInfo.conferenceRoomActive === true) {
              // 내부망 - CMS 미팅
              saehaAuthenticationUrl = "/api/auth/saehaInfo";
            } else {
              // 내부망 - 일반회의
              saehaAuthenticationUrl = "/api/auth/joinUrlForSaehaInfo";
            }
          }

          if (data.meetingInfo.conferenceRoomActive === true) {
            // cms 미팅
            this.$http
              .get(saehaAuthenticationUrl, { params: params })
              .then(response => {
                let info = response.data;

                const ds = this.$BodaApp.defaultSettings(info.ds);
                this.bodaFileLink = info.bodaFileLink;
                
                this.$BodaApp.openJoin(
                  {
                    roomCode: info.meetingInfo.meetingKey,
                    template: Number(info.oj.template),
                    title: info.meetingInfo.title,
                    userType: info.oj.joinUserType,
                    userId: info.userData.userId,
                    userName: info.userData.userName,
                    openOption: info.oj.openOption ? info.oj.openOption : '',
                    joinOption: info.oj.joinOption ? info.oj.joinOption : '',
                    appOption: { Q: { QSchm: 'ksdflow://' } },
                  },
                  () => {
                    console.log("success");
                    window.open("", "_self").close();
                    window.close();
                  },
                  (errorCode, reason) => {
                    if (isMb !== 'mb') {
                      if (
                        errorCode === "BODA-NOT_INSTALLED" ||
                        errorCode === "BODA-NOT_CONNECTED_AGENT"
                      ) {
                        alert(
                          "영상회의 클라이언트 설치가 필요합니다."
                        );
                        this.$BodaApp.downloadClient(
                          {},
                          function () {
                            // 성공 시 처리
                          },
                          function (errorCode, reason) {
                            // 오류 시 처리
                          }
                        );
                      } else if (errorCode === "BODA-UNDEFINED_ERROR") {
                        if (reason === "CLIENT_RUNNING") {
                          alert(
                            "영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요."
                          );
                        }
                      }
                    } else {
                      window.open("", "_self").close();
                      window.close();
                    }
                    this.loading = false;
                  }
                );
              });
          } else {
            // 일반 회의
            this.$http
              .get(saehaAuthenticationUrl, { params: params })
              .then(response => {
                let info = response.data;
                console.log(`info`, info)
                const ds = this.$BodaApp.defaultSettings(info.ds);
                this.bodaFileLink = info.bodaFileLink;
                
                this.$BodaApp.openJoin(
                  {
                    roomCode: info.meetingInfo.meetingKey,
                    template: Number(info.oj.template),
                    title: info.meetingInfo.title === '' ? info.userData.userName : info.meetingInfo.title,
                    userType: info.oj.joinUserType,
                    userId: info.userData.userId,
                    userName: info.userData.userName + `/${info.userData.callNm}`,
                    openOption: info.meetingInfo.roomOption
                    ? info.meetingInfo.roomOption
                    : '',
                    appOption: isMb === 'mb' ? { Q: { QSchm: 'ksdflow://' } } : '',
                  },
                  () => {
                    setTimeout(() => {
                      window.close();
                    }, 1000);
                    
                  },
                  (errorCode, reason) => {
                    if (isMb !== 'mb') {
                      if (
                        errorCode === "BODA-NOT_INSTALLED" ||
                        errorCode === "BODA-NOT_CONNECTED_AGENT"
                      ) {
                        alert(
                          "영상회의 클라이언트 설치가 필요합니다."
                        );
                        this.$BodaApp.downloadClient(
                          {},
                          function () {
                            // 성공 시 처리
                          },
                          function (errorCode, reason) {
                            // 오류 시 처리
                          }
                        );
                      } else if (errorCode === "BODA-UNDEFINED_ERROR") {
                        if (reason === "CLIENT_RUNNING") {
                          alert(
                            "영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요."
                          );
                        }
                      }
                    } else {
                      window.open("", "_self").close();
                      window.close();
                    }
                  }
                );
              });
          }
          
        });
      return false;
    },
    confirmAgree () {
      // 동의 완료
      this.confirmDialog.dialog = false;
      this.startMeeting();
    },
    closeConfirm () {
      this.confirmDialog.dialog = false;
      this.$window.open("", "_self").close();
      this.$window.close();
    },
    joinPwMeeting () {
      this.checkPasswordDialog.dialog = false;
      this.isCheckedPassword = true;
      this.startMeeting();
    },
    closePassword () {
      this.checkPasswordDialog.dialog = false;
    },
    showInterval () {
      setTimeout(() => {
        // Code here
        /* this.isShow = 'none'; */
        /* this.isLodingShow = 'none'; */
        alert("종료된 회의입니다.");
        this.$window.open("", "_self").close();
        this.$window.close();
      }, 3000);
    },
    getURLParameter (sParam) {
      let sPageURL = window.location.search.substring(1);
      let sURLVariables = sPageURL.split("&");
      for (let i = 0; i < sURLVariables.length; i++) {
        let sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] === sParam) {
          return sParameterName[1];
        }
      }
    },
    downloadClient () {
      /* alert('영상회의 클라이언트가 설치되어있지 않습니다. 설치 후 이용해주세요.'); */
      let os = Util.getOS();
      if (os.indexOf("window") !== -1) {
        let file_path = this.bodaFileLink;
        if (
          window.navigator.platform === "win32" &&
          window.navigator.cpuClass === "x86"
        ) {
          file_path.replace("groupcode=15", "groupcode=12&bit=32");
        }
        let a = document.createElement("A");
        a.href = file_path;
        a.download = file_path.substr(file_path.lastIndexOf("/") + 1);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    winClose () {
      top.window.open("about:blank", "_self").close();
      top.window.opener = self;
      top.self.close();
    },
  },
};
</script>
<style scoped>
.join-btn {
  background: #7dc3ff;
  width: 300px;
  font-size: 25pt;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  display: inline-block;
  margin-top: 30px;
}

.download-header {
  background: #1457aa;
  color: white;
  font-weight: 300;
}

.download-contents {
  font-size: 13pt;
  padding: 10px 0;
  font-weight: 100;
}
#downloadBtn {
  width: 200px;
  height: 50px;
  background: #1457aa;
  display: inline-block;
  color: white;
  border-radius: 5px;
  font-size: 14pt;
  margin-top: 20px;
  line-height: 50px;
  cursor: pointer;
}

#closeBtn {
  width: 100px;
  height: 40px;
  background: #9fa9ae;
  display: inline-block;
  color: white;
  border-radius: 5px;
  font-size: 14pt;
  margin-top: 10px;
  line-height: 40px;
  margin-bottom: 20px;
  cursor: pointer;
}

#here {
  width: 100%;
  text-align: center;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.02) 0%,
      rgba(0, 0, 0, 0.02) 100%
    ),
    linear-gradient(
      0deg,
      rgba(0, 143, 111, 0.08) 0%,
      rgba(0, 143, 111, 0.08) 100%
    ),
    #fff;
}

.attend-main-title {
  color: #333;
  text-align: center;
  font-family: "Noto Sans KR";
  font-size: 52px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 78px */
  letter-spacing: -1.04px;
  margin-top: 10%;
}

.attend-btn {
  border-radius: 12px;
  border: 1px solid #008f6f;
  background: #fff;
  display: inline-flex;
  padding: 18px 48px;
  flex-direction: column;
  align-items: flex-start;
  color: #008f6f;
  text-align: center;
  font-family: "Noto Sans KR";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 30px */
  letter-spacing: -0.4px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/sections/AttendMeeting.vue